import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

//
import enLocales from './en.json';
import ltLocales from './lt.json';
import ruLocales from './ru.json';
import lvLocales from './lv.json';
import eeLocales from './ee.json';

// ----------------------------------------------------------------------

const languageByHostname = () => {
  const hostname = window.location.hostname.split('.').slice(-1).toString().toLowerCase();

  switch (hostname) {
    case 'lt':
      return 'lt';
    case 'lv':
      return 'lv';
    case 'ee':
      return 'ee';
    case 'ru':
      return 'ru';
    default:
      return 'en';
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enLocales },
      lt: { translations: ltLocales },
      lv: { translations: lvLocales },
      ee: { translations: eeLocales },
      ru: { translations: ruLocales },
    },
    lng: localStorage.getItem('i18nextLng') || languageByHostname(),
    fallbackLng: 'en',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
